module.exports = __webpack_public_path__ + "images/emoji/man.06ef89fb0ce1139eccde.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/man.png
// module id = QgC1
// module chunks = 2